import {
    Box,
    Card,
    CardContent,
    CardMedia,
    Typography,
    Chip,
    CardActionArea,
    Button
} from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import PublicIcon from '@mui/icons-material/Public';
import InstagramIcon from '@mui/icons-material/Instagram';
import EditVenueButton from "./Button/EditVenueButton.jsx";
import ReactMarkdown from "react-markdown";
import Link from '@mui/material/Link';

// VenueCard component to display individual venue
const VenueCard = ({ venue, showCityState }) => {

    return (
        <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
          {venue.images && <CardMedia sx={{ height: 140 }} image={venue.images[0].url} title={venue.name} />} 
    
          <CardContent>
            <Typography variant="h5" component="div">
                {venue.name}
            </Typography>
            {showCityState && <Typography>{venue.city}, {venue.state}</Typography>}
            {venue.location && <Typography component="div" variant={"overline"}>{venue.location}</Typography>}

            <Box mt={1} mb={2}>
                {venue.cover && (
                    <div><Chip size="small" label={`Cover: ${venue.cover}`} /></div>
                )}
                {venue.age && (
                    <div><Chip size="small" label={`${venue.age}`} /></div>
                )}

                {venue.hasOwnProperty("eventCount") && <Box mb={1} mt={2}>
                    <Typography variant={"body2"}>{venue.eventCount} upcoming events</Typography>
                </Box>}
            </Box>

            {venue.website && <Box sx={{ display: 'flex', alignItems: 'top', mb: 1 }}>
              <Button href={venue.website} size={"small"} startIcon={<PublicIcon fontSize="small" color="primary" target={"_blank"} sx={{ mr: 0.5 }} />}>
                  {venue.website.toLowerCase().replace("https://","").replace("http://","").replace("www.","")}
              </Button>
          </Box>}

            {venue.insta && <Box sx={{ display: 'flex', alignItems: 'top', mb: 1 }}>
            <Button href={`https://www.instagram.com/${venue.insta}`} size={"small"} startIcon={<InstagramIcon fontSize="small" color="primary" target={"_blank"} sx={{ mr: 0.5 }} />}>
              {venue.insta}
            </Button>
          </Box>}

            {venue.daysToVisit && venue.daysToVisit.length > 0 && (
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <CalendarTodayIcon fontSize="small" color="primary" sx={{ mr: 0.5 }} />
              <Typography variant="body2" color="text.secondary">
                Best days to visits: {venue.daysToVisit}
              </Typography>
            </Box>
            )}

            <Box
              sx={{
                position: "relative",
                height: "100px",
                overflow: "hidden",
                mb: 2,
                scroll: "auto",
                overflowY: "scroll",
              }}
            >
              <Typography variant={"body2"}>
                <ReactMarkdown components={{ a: Link }}>
                  {venue.whatToExpect}
                </ReactMarkdown>
              </Typography>
        
            </Box>
        </CardContent>
            <CardActionArea>
                <Box ml={1}>
                    <Button href={"/venue/" + venue.venueKey}>More Info</Button>
                    {/* <EditVenueButton venue={venue} /> */}
                </Box>
      </CardActionArea>
    </Card>
    );
};

export default VenueCard;